<template>
  <div class="big">
    <div class="page_title flex between">
      <span> 编辑标签</span>
      <el-button type="primary" style="width: 92px" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div class="title">基本信息</div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-form-item label="标签名称" prop="label_name">
              <el-input
                v-model="ruleForm.label_name"
                maxlength="50"
                style="width: 300px"
              ></el-input>
            </el-form-item>
            <el-form-item label="标签分类" prop="label_category_id">
              <el-select
                style="width: 300px"
                v-model="ruleForm.label_category_id"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in label_List"
                  :key="index"
                  :label="item.label_category_name"
                  :value="item.label_category_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                maxlength="500"
                show-word-limit
                v-model="ruleForm.label_remark"
                style="width: 500px"
              >
              </el-input>
            </el-form-item>
            <div class="title" style="margin-top: 50px">创建规则</div>
            <el-form-item label="创建方式" required="">
              <el-select
                style="width: 300px"
                v-model="ruleForm.create_type"
                placeholder="请选择"
                @change="changeType"
                disabled
              >
                <el-option label="自定义标签值" :value="1"> </el-option>
                <el-option label="SQL计算结果" :value="2"> </el-option>
                <el-option label="导入创建" :value="3"> </el-option>
              </el-select>
            </el-form-item>
            <!-- 自定义标签值 -->
            <div v-if="ruleForm.create_type == 1">
              <el-form-item
                style="margin: -20px 0 -1px"
                label="创建规则"
                required=""
              >
                <span class="info"
                  >在全部医生中，将满足以下条件的医生标记为当前标签</span
                >
              </el-form-item>
              <div class="label_box">
                <div>
                  <span style="margin-right: 10px" class="little_title"
                    >标签规则</span
                  >
                  <span>
                    是否同时满足属性及行为条件
                    <el-radio-group
                      v-model="ruleForm.param_detail.logic"
                      style="margin-left: 5px"
                    >
                      <el-radio label="and">是</el-radio>
                      <el-radio label="or">否</el-radio>
                    </el-radio-group>
                  </span>
                </div>
                <!-- 医生属性/数据满足 -->
                <div class="rule_box">
                  <div class="flex_between">
                    <span>
                      <span class="little_title">医生属性/数据满足</span>
                      <span>
                        是否同时满足以下属性条件
                        <el-radio-group
                          v-model="attribute.logic"
                          style="margin-left: 5px"
                        >
                          <el-radio label="and">是</el-radio>
                          <el-radio label="or">否</el-radio>
                        </el-radio-group>
                      </span>
                    </span>
                    <el-button
                      type="primary"
                      size="medium"
                      @click="addAttribute"
                      >添加</el-button
                    >
                  </div>
                  <div
                    v-for="(attr, attr_key, index) in attribute"
                    :key="index"
                  >
                    <div v-if="attr_key != 'logic'" class="attr flex_between">
                      <div>
                        <div v-for="(item, item_key, i) in attr" :key="i">
                          <div
                            v-if="item_key != 'logic'"
                            class="attr_item flex_between"
                          >
                            <div>
                              <!-- 属性数据 -->
                              <el-select
                                v-model="item.field"
                                placeholder="请选择"
                                size="medium"
                                style="width: 200px"
                              >
                                <el-option
                                  v-for="item in nature_List"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                                >
                                </el-option>
                              </el-select>
                              <!-- 属性运算符号 -->
                              <el-select
                                v-model="item.compute"
                                placeholder="请选择"
                                size="medium"
                                style="width: 90px; margin: 0 15px"
                              >
                                <el-option
                                  v-for="item in nature_compute"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                                >
                                </el-option>
                              </el-select>
                              <el-input
                                placeholder="请输入内容"
                                v-model="item.value"
                                class="input-with-select"
                                disabled
                                style="width: 320px"
                                size="medium"
                              >
                              </el-input>
                              <el-button
                                icon="el-icon-edit"
                                size="medium"
                                @click="
                                  addValue(attr_key, item_key, item.value)
                                "
                              ></el-button>
                            </div>
                            <el-button
                              type="text"
                              icon="el-icon-delete"
                              style="margin-left: 30px"
                              @click="deleteAttribute(attr_key, item_key)"
                            ></el-button>
                          </div>
                        </div>
                      </div>
                      <div class="attr_right">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="addAttributeItem(attr_key)"
                          >添加</el-button
                        >
                        <div>
                          <div style="margin: 20px 0 10px">
                            左边条件是否同时满足
                          </div>
                          <div>
                            <el-radio-group
                              v-model="attr.logic"
                              style="margin-left: 5px"
                            >
                              <el-radio label="and">是</el-radio>
                              <el-radio label="or">否</el-radio>
                            </el-radio-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 医生行为满足 -->
                <div class="rule_box">
                  <div class="flex_between">
                    <span>
                      <span class="little_title">医生行为满足</span>
                      <span>
                        是否同时满足以下行为条件
                        <el-radio-group
                          v-model="behavior.logic"
                          style="margin-left: 5px"
                        >
                          <el-radio label="and">是</el-radio>
                          <el-radio label="or">否</el-radio>
                        </el-radio-group>
                      </span>
                    </span>
                    <el-button type="primary" size="medium" @click="addBehavior"
                      >添加</el-button
                    >
                  </div>
                  <div v-for="(be, be_key, index) in behavior" :key="index">
                    <div v-if="be_key != 'logic'" class="attr flex_between">
                      <div>
                        <div v-for="(item, item_key, i) in be" :key="i">
                          <div
                            v-if="item_key != 'logic'"
                            class="attr_item flex_between"
                          >
                            <div>
                              <el-select
                                v-model="item.time_type"
                                size="medium"
                                style="width: 120px"
                              >
                                <el-option label="具体时间段" :value="1">
                                </el-option>
                                <el-option label="动态时间段" :value="2">
                                </el-option>
                              </el-select>
                              <el-date-picker
                                v-if="item.time_type == 1"
                                v-model="item.date"
                                type="daterange"
                                range-separator="~"
                                start-placeholder="开始"
                                end-placeholder="结束"
                                size="medium"
                                style="width: 225px; margin: 0 10px"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                @change="
                                  (value) => {
                                    return changeDate(value, be_key, item_key);
                                  }
                                "
                              >
                              </el-date-picker>
                              <span
                                style="margin: 0 10px"
                                v-if="item.time_type == 2"
                              >
                                过去
                                <el-input-number
                                  style="width: 80px"
                                  v-model="item.day_time"
                                  :min="1"
                                  :max="1000"
                                  :precision="0"
                                  :controls="false"
                                  size="medium"
                                ></el-input-number
                                >天
                              </span>
                              <el-select
                                v-model="item.compute"
                                size="medium"
                                style="width: 90px"
                                placeholder=""
                                @change="
                                  (value) => {
                                    return changeDoing(value, be_key, item_key);
                                  }
                                "
                              >
                                <el-option
                                  v-for="item in doing_List"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                                >
                                </el-option>
                              </el-select>
                              <el-select
                                v-model="item.field"
                                size="medium"
                                style="width: 140px; margin: 0 10px"
                                placeholder=""
                              >
                                <el-option
                                  v-for="item in behavior_List"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                                >
                                </el-option>
                              </el-select>
                              <el-select
                                v-if="item.compute == 1"
                                v-model="item.times"
                                size="medium"
                                style="width: 110px"
                                placeholder=""
                                @change="
                                  (value) => {
                                    return changeTimes(value, be_key, item_key);
                                  }
                                "
                              >
                                <el-option label="次数" :value="1"> </el-option>
                                <el-option label="次数不限" :value="0">
                                </el-option>
                                <el-option label="金额" :value="2"> </el-option>
                              </el-select>
                              <el-select
                                v-if="item.compute == 1 && item.times"
                                v-model="item.reckon"
                                size="medium"
                                style="width: 100px; margin: 0 10px"
                                placeholder=""
                              >
                                <el-option
                                  v-for="item in operation_List"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                                >
                                </el-option>
                              </el-select>
                              <el-input-number
                                v-if="item.compute == 1 && item.times"
                                style="width: 80px"
                                v-model="item.count"
                                :min="0"
                                :precision="0"
                                :controls="false"
                                size="medium"
                              ></el-input-number>
                            </div>
                            <el-button
                              type="text"
                              icon="el-icon-delete"
                              style="margin-left: 30px"
                              @click="deleteBehavior(be_key, item_key)"
                            ></el-button>
                          </div>
                        </div>
                      </div>
                      <div class="attr_right">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="addBehaviorItem(be_key)"
                          >添加</el-button
                        >
                        <div>
                          <div style="margin: 20px 0 10px">
                            左边条件是否同时满足
                          </div>
                          <div>
                            <el-radio-group
                              v-model="be.logic"
                              style="margin-left: 5px"
                            >
                              <el-radio label="and">是</el-radio>
                              <el-radio label="or">否</el-radio>
                            </el-radio-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 10px">
                  <span style="margin-right: 10px" class="little_title"
                    >排序方式</span
                  >
                  <el-select
                    style="width: 200px; margin: 0 10px"
                    v-model="ruleForm.sort_type"
                    placeholder="请选择"
                  >
                    <el-option
                      :label="item.value"
                      :value="item.id"
                      v-for="(item, index) in orderby_list"
                      :key="index"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    style="width: 100px"
                    v-model="ruleForm.sort_num"
                    placeholder="请选择"
                  >
                    <el-option label="升序" :value="1"> </el-option>
                    <el-option label="降序" :value="2"> </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <!-- SQL计算 -->
            <div style="margin-bottom: 60px" v-if="ruleForm.create_type == 2">
              <el-form-item
                style="margin: -20px 0 -1px"
                label="创建规则"
                required=""
              >
                <span class="info"
                  >按照SQL规则进行执行，建议规则中不要包含当日及以后的的数据</span
                >
              </el-form-item>
              <el-form-item label="SQL规则" prop="content">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="查询的结果需返回2列值：第一列为医生ID，第二列为标签值"
                  v-model="ruleForm.content"
                  style="width: 1000px"
                >
                </el-input>
              </el-form-item>
            </div>
            <!-- 导入创建 -->
            <div v-if="ruleForm.create_type == 3">
              <el-form-item
                style="margin: -20px 0 -1px"
                label="创建规则"
                required=""
              >
                <span class="info"
                  >上传文件，通过医生属性筛选目标医生，对目标医生进行标记</span
                >
              </el-form-item>
              <el-form-item label="上传文件" required="">
                <div class="flex">
                  <el-upload
                    class="avatar-uploader"
                    name="image"
                    :action="uploadUrl"
                    :data="uploadExtraData"
                    :headers="uploadHeaders"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeUpload"
                  >
                    <el-button v-if="ruleForm.content" size="medium"
                      >重新选择</el-button
                    >
                    <el-button type="primary" v-else size="medium"
                      >选择文件</el-button
                    >
                  </el-upload>
                  <el-button
                    style="margin-left: 30px"
                    type="text"
                    @click="download"
                    >下载模板</el-button
                  >
                </div>
              </el-form-item>
              <div style="padding-left: 130px" v-if="file_name">
                <span>上传文件：</span>
                <span style="color: #666">{{ file_name }}</span>
              </div>
              <ul style="color: #999; padding-left: 135px">
                <li>上传文件时需上传属性及属性值</li>
                <li>
                  属性与属性值不匹配，或属性不存在时，会被当作无效数据过滤
                </li>
                <li>
                  若文件中多个属性与属性值匹配到同一个医生，则当前医生仅标记一次
                </li>
                <li>若文件中多个属性，多个属性之间为“且”的关系</li>
                <li>
                  若文件中某个属性有多个属性值，多个属性值之间为“或”的关系
                </li>
              </ul>
            </div>

            <el-form-item label="更新方式" required="">
              <el-radio-group v-model="ruleForm.update_type" disabled>
                <el-radio :label="1">手动</el-radio>
                <span
                  class="info"
                  style="margin-right: 20px"
                  v-if="ruleForm.update_type == 1"
                  >(标签生成后，点击“更新”按钮进行数据的更新)</span
                >
                <el-radio :label="2">例行</el-radio>
                <span class="info" v-if="ruleForm.update_type == 2"
                  >(每天计算，标签每日凌晨3:00更新)</span
                >
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div style="text-align: center; margin-top: 50px">
            <el-button
              style="width: 92px"
              type="primary"
              @click="submit('ruleForm')"
              >创建</el-button
            >
            <el-button style="width: 92px" @click="back">取消</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="编辑属性值"
      :visible.sync="add_attribute_value"
      width="600px"
      :close-on-click-modal="false"
    >
      <div style="text-align: left; padding: 20px">
        <div style="color: #ff1f1f; margin-bottom: 20px">
          注意：按逗号分隔，最多输入 5000 条
        </div>
        <div>
          <el-input
            type="textarea"
            :rows="8"
            placeholder="请输入内容"
            show-word-limit
            v-model="attribute_value"
          >
          </el-input>
        </div>
      </div>
      <div style="text-align: center; padding-bottom: 20px">
        <span slot="footer" class="dialog-footer">
          <el-button
            plain
            @click="add_attribute_value = false"
            style="width: 92px"
            size="medium"
            >取消</el-button
          >
          <el-button
            type="primary"
            style="width: 92px"
            size="medium"
            @click="saveValue"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import _ from "lodash";
import constant from "../../../service/common/constant";

export default {
  data() {
    return {
      label_List: [], //标签分类
      nature_List: [], //属性list
      behavior_List: [], //行为list
      doing_List: [], //做过 未做过
      nature_compute: [], //属性符号
      operation_List: [], //行为符号
      orderby_list: [], //自定义标签排序
      add_attribute_value: false,
      attribute_value: "",
      file_name: "",
      uploadExtraData: {
        img_type: 6,
        suffix: ".jpg",
      },
      ruleForm: {
        label_name: "",
        label_category_id: "",
        label_remark: "",
        create_type: 1,
        update_type: 1,
        content: "",
        sort_type: 1,
        sort_num: 1,
        param_detail: {
          logic: "or",
        },
      },
      rules: {
        label_name: [
          {
            required: true,
            message: "请输入标签名称",
            trigger: "blur",
          },
        ],
        label_category_id: [
          { required: true, message: "请选择标签分类", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入SQL规则", trigger: "blur" },
        ],
      },
      attribute_list: [
        { label: "医生id", value: "doctor_id" },
        { label: "医生科室", value: "department_name" },
        { label: "所属省份", value: "province_name" },
        { label: "医生所在地级市", value: "city_name" },
        { label: "医生名", value: "doctor_name" },
        { label: "医生手机号", value: "doctor_phone" },
        { label: "医生所属医院", value: "hospital" },
      ],
      is_and: 1,
      attribute: {
        logic: "or",
      },
      behavior: {
        logic: "or",
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        return "/api/platform/upload/uploadFile";
      } else {
        return "/platform/upload/uploadFile";
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ["version", "platform"]),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken,
        }
      );
    },
  },

  methods: {
    //医生标签分类
    doctorLabelCategory() {
      this.axios.post("platform/Doctor/doctorLabelCategory").then((res) => {
        this.label_List = res.data.list;
      });
    },
    //属性/数据列表
    doctorNatureList() {
      this.axios.post("platform/Doctor/doctorNatureList").then((res) => {
        this.nature_List = res.data.list;
      });
    },
    //用户行为
    doctorBehaviorList() {
      this.axios.post("platform/Doctor/doctorBehaviorList").then((res) => {
        this.behavior_List = res.data.list;
      });
    },
    //标签行为做过/未做过
    doctorDoing() {
      this.axios.post("platform/Doctor/doctorDoing").then((res) => {
        this.doing_List = res.data.list;
      });
    },
    //标签行为运算符号
    doctorOperation() {
      this.axios.post("platform/Doctor/doctorOperation").then((res) => {
        this.operation_List = res.data.list;
      });
    },
    //属性/数据 运算符号
    natureComputeSymbol() {
      this.axios.post("platform/Doctor/natureComputeSymbol").then((res) => {
        this.nature_compute = res.data.list;
      });
    },
    //获取医生自定义标签排序
    doctorOrderBy() {
      this.axios.post("platform/doctor/doctorOrderBy").then((res) => {
        this.orderby_list = res.data.list;
      });
    },
    //添加属性大类
    addAttribute() {
      let arr = Object.keys(this.attribute);
      let i = "";
      if (arr.length >= 2) {
        i = Number(arr[arr.length - 2]) + 1;
      } else {
        i = 0;
      }
      let data = {
        0: {
          field: "",
          compute: "",
          value: "",
        },
        logic: "or",
      };
      this.$set(this.attribute, i, data);
    },
    //添加属性行
    addAttributeItem(attr_key) {
      let arr = Object.keys(this.attribute[attr_key]);
      let i = "";
      if (arr.length >= 2) {
        i = Number(arr[arr.length - 2]) + 1;
      } else {
        i = 0;
      }
      let data = {
        field: "",
        compute: "",
        value: "",
      };
      this.$set(this.attribute[attr_key], i, data);
    },
    //删除属性行
    deleteAttribute(attr_key, item_key) {
      this.attribute[attr_key] = _.omit(this.attribute[attr_key], item_key);
      let arr = Object.keys(this.attribute[attr_key]);
      if (arr.length == 1) {
        this.attribute = _.omit(this.attribute, attr_key);
      }
    },
    //添加属性值
    addValue(attr_key, item_key, attr_value) {
      this.attr_key = attr_key;
      this.item_key = item_key;
      if (attr_value) {
        this.attribute_value = attr_value;
      } else {
        this.attribute_value = "";
      }
      this.add_attribute_value = true;
    },
    //保存属性值
    saveValue() {
      let arr = this.attribute_value.split(",");
      arr = arr.filter((item) => item);
      if (arr.length > 5000) {
        this.$message.error("最多输入 5000 条数据");
        return false;
      }
      this.attribute[this.attr_key][this.item_key].value = arr.toString();
      this.add_attribute_value = false;
    },
    //添加行为大类
    addBehavior() {
      let arr = Object.keys(this.behavior);
      let i = "";
      if (arr.length >= 2) {
        i = Number(arr[arr.length - 2]) + 1;
      } else {
        i = 0;
      }
      let data = {
        0: {
          date: "",
          compute: "",
          field: "",
          reckon: "",
          count: undefined,
        },
        logic: "or",
      };
      this.$set(this.behavior, i, data);
    },
    //添加行为行
    addBehaviorItem(be_key) {
      let arr = Object.keys(this.behavior[be_key]);
      let i = "";
      if (arr.length >= 2) {
        i = Number(arr[arr.length - 2]) + 1;
      } else {
        i = 0;
      }
      let data = {
        date: [],
        compute: "",
        field: "",
        reckon: "",
        count: undefined,
      };
      this.$set(this.behavior[be_key], i, data);
    },
    //删除行为行
    deleteBehavior(be_key, item_key) {
      this.behavior[be_key] = _.omit(this.behavior[be_key], item_key);
      let arr = Object.keys(this.behavior[be_key]);
      if (arr.length == 1) {
        this.behavior = _.omit(this.behavior, be_key);
      }
    },
    changeDate(value, be_key, item_key) {
      if (value && value.length) {
        this.behavior[be_key][item_key].start_time = value[0];
        this.behavior[be_key][item_key].end_time = value[1];
      } else {
        this.behavior[be_key][item_key].start_time = "";
        this.behavior[be_key][item_key].end_time = "";
      }
    },
    //做过 未做过
    changeDoing(value, be_key, item_key) {
      if (!value) {
        this.behavior[be_key][item_key].reckon = "";
        this.behavior[be_key][item_key].times = 0;
        this.behavior[be_key][item_key].count = undefined;
      }
    },
    //次数限制
    changeTimes(value, be_key, item_key) {
      if (!value) {
        this.behavior[be_key][item_key].reckon = "";
        this.behavior[be_key][item_key].count = undefined;
      }
      this.$forceUpdate();
    },

    //提交创建
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.create_type == 1) {
            let data = this.ruleForm;
            data.param_detail.attribute = this.attribute;
            data.param_detail.behavior = this.behavior;
            data.label_id = this.$route.query.label_id;
            this.axios
              .post("platform/Doctor/createDoctorCustomLabel", data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success("创建成功");
                  this.back();
                }
              });
          }
          if (this.ruleForm.create_type == 2) {
            let data = this.ruleForm;
            data.label_id = this.$route.query.label_id;
            this.axios
              .post("platform/Doctor/createDoctorSqlLable", data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success("创建成功");
                  this.back();
                }
              });
          }
          if (this.ruleForm.create_type == 3) {
            let data = this.ruleForm;
            data.label_id = this.$route.query.label_id;
            data.file_name = this.file_name;
            this.axios
              .post("platform/Doctor/importDoctorLable", data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success("创建成功");
                  this.back();
                }
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeType(type) {
      if (type != 1) {
        this.ruleForm.content = "";
      }
    },
    //上传之前
    beforeUpload(file) {
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isText && !isTextComputer) {
        this.$message.error("上传文件只能是CSV或Excel文件");
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf("."));
      this.uploadExtraData.suffix = suffix;
      return isText || isTextComputer;
    },
    //上传成功
    handleAvatarSuccess(res, file) {
      if (res.code === 0) {
        this.file_name = file.name;
        this.ruleForm.content = res.data.pic;
      }
    },
    //下载模板
    download() {
      let host =
        document.location.protocol +
        "//" +
        window.location.host +
        "/upload/doctor_label.xls";
      location.href = host;
    },
    back() {
      history.back();
    },
  },
  created() {
    let type = Number(this.$route.query.create_type);
    this.ruleForm.create_type = type;
    this.doctorOrderBy();
    this.doctorLabelCategory();
    this.natureComputeSymbol();
    this.doctorNatureList();
    this.doctorBehaviorList();
    this.doctorDoing();
    this.doctorOperation();

    let label_id = this.$route.query.label_id;
    if (type == 1) {
      this.axios
        .post("platform/Doctor/doctorCustomLableInfo", { label_id })
        .then((res) => {
          if (res.code == 0) {
            this.ruleForm = {
              label_name: res.data.label_name,
              label_category_id: res.data.label_category_id,
              label_remark: res.data.label_remark,
              create_type: type,
              update_type: res.data.update_type,
              sort_type: res.data.sort_type,
              sort_num: res.data.sort_num,
              param_detail: {
                logic: res.data.detail.logic,
              },
            };
            this.attribute = res.data.detail.attribute;
            let data = res.data.detail.behavior;
            for (const i in data) {
              if (i != "logic") {
                for (const j in data[i]) {
                  if (j != "logic") {
                    if (data[i][j].start_time) {
                      data[i][j].start_time = dayjs
                        .unix(data[i][j].start_time)
                        .format("YYYY-MM-DD");
                      data[i][j].end_time = dayjs
                        .unix(data[i][j].end_time)
                        .format("YYYY-MM-DD");
                      data[i][j].date = [
                        data[i][j].start_time,
                        data[i][j].end_time,
                      ];
                    }
                    // if (data[i][j].reckon) {
                    //   data[i][j].times = 1;
                    // }
                    // if (data[i][j].compute && !data[i][j].reckon) {
                    //   data[i][j].times = 0;
                    // }
                  }
                }
              }
            }
            this.behavior = data;
          }
        });
    }
    if (type == 2) {
      this.axios
        .post("platform/Doctor/getDoctorSqlLableInfo", { label_id })
        .then((res) => {
          if (res.code == 0) {
            this.ruleForm = {
              label_name: res.data.label_name,
              label_category_id: res.data.label_category_id,
              label_remark: res.data.label_remark,
              create_type: type,
              update_type: res.data.update_type,
              content: res.data.sql_content,
            };
          }
        });
    }
    if (type == 3) {
      this.axios
        .post("platform/Doctor/getDoctorSqlLableInfo", { label_id })
        .then((res) => {
          if (res.code == 0) {
            this.file_name = res.data.file_name;
            this.ruleForm = {
              label_name: res.data.label_name,
              label_category_id: res.data.label_category_id,
              label_remark: res.data.label_remark,
              create_type: type,
              update_type: res.data.update_type,
              content: res.data.sql_content,
            };
          }
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
  padding-bottom: 10px;
}
.title {
  font-size: 16px;
  font-weight: 700;
  padding: 20px 0 20px 100px;
}
.little_title {
  font-size: 15px;
  font-weight: 700;
}
.info {
  color: #888;
  font-size: 13px;
}
.label_box {
  margin-left: 100px;
}
.rule_box {
  margin-top: 10px;
  padding: 12px;
  width: 1210px;
  border: 1px solid #ccc;
}
.attr {
  border: 1px solid #ccc;
  padding: 10px;
  margin-top: 12px;
  background: #f9f9f9;
}
.attr_right {
  padding-left: 10px;
  border-left: 1px solid #ccc;
  width: 200px;
  text-align: center;
}
.attr_item {
  padding: 3px 0;
}
</style>
<style lang="scss">
.el-textarea__inner {
  //el_input中的隐藏属性
  resize: none; //主要是这个样式
}
</style>
